import { FetchRetailRequestTypes } from '../actions/RetailActions';
import { makeRequestStatusSelector } from './RequestStatusSelectors';
export const isRetailSelector = ({
  retail
}) => retail;
export const fetchRetailStatus = makeRequestStatusSelector(FetchRetailRequestTypes.REQUEST);